export default {
  landingInfo: {
    externalURL: 'https://www.securitize.io',
    platformURL: 'securitze.securitize.io',
    clientId: '31843138912',
    clientKey: 'KDN9013320',
    enablePage: true,
    enableLimitAccess: true,
    password: '23kj4h23j4h23j',
    basicMode: true,
    mode: 'loginOnly',
    loginButtonText: 'Login',
    registrationButtonText: 'Request Information',
    headline: 'This is a Headline',
    basicText: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. 
    Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, 
    nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. 
    Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. 
    In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.`,
  },
  investorArea: {
    announcement: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    aboutText: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. 
    Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, 
    nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. 
    Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. 
    In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.`,
    aboutYoutube: 'https://www.youtube.com/watch?v=pDwAlcATeCQ',
    facebook: 'https://www.facebook.com/isser_name',
    twitter: 'https://www.twitter.com/isser_name',
    telegram: 'https://www.t.me/isser_name',
    medium: 'https://www.medium.com/isser_name',
    subtitle: '',
    aboutTitle: 'Come build together',
    aboutContent: 'Join this opportunity to become part of our investor community.',
  },
  customEmail: 'info@securitize.io',
  configuration: {
    general: {
      colorScheme: {},
      images: {},
    },
    landingPage: {
      basic: {
        limitedAccess: {},
        restrictLogin: 'disabled',
      },
      external: {},
    },
    investorsArea: {
      about: {
        Text: '',
      },
      announcements: {},
      wizard: {},
      socialLinks: {},
    },
  },
  isLoading: false,
  tokenConfiguration: {},
};
